module.exports = __webpack_public_path__ + "static/media/summerduchesne.84321091.webp";